<template>
  <jtCard
    containerHeight="430"
    title="铁路货物发送到达统计"
    style="margin-bottom: 30px"
  >
  <div style="height:340px" class="flex">
    <div style="">
      <div class="flex" style="margin-bottom:75px">
        <img src="@/assets/images/icon1.png" class="img">
        <div>
          <div class="itme1_title" style="color: #2DF9CC;">日常发车</div>
          <div class="item1_num" style="color: #29F8E9;">4968</div>
        </div>
      </div>
      <div class="flex" style="">
        <img src="@/assets/images/icon_4.png" class="img">
        <div>
          <div class="itme1_title" style="color: #41EDFF;">累计到达车</div>
          <div class="item1_num" style="color: #4FEEFF;">4968</div>
        </div>
      </div>
    </div>
    <div>
      <div class="flex" style="margin-bottom:75px">
        <img src="@/assets/images/icon_2.png" class="img">
        <div>
          <div class="itme1_title" style="color: #CDDA48;">日到达车</div>
          <div class="item1_num" style="color: #EFFF72;">4968</div>
        </div>
      </div>
      <div class="flex" style="">
        <img src="@/assets/images/icon_5.png" class="img">
        <div>
          <div class="itme1_title" style="color: #34DAFA;">日发送吨</div>
          <div class="item1_num" style="color: #34DAFA;">4968</div>
        </div>
      </div>
    </div>
    <div>
      <div class="flex" style="margin-bottom:75px">
      <img src="@/assets/images/icon_3.png" class="img">
      <div>
        <div class="itme1_title" style="color: #97CAFF;">累计发送车</div>
        <div class="item1_num" style="color: #A4D1FF;">4968</div>
      </div>
    </div>
    <div class="flex" style="">
      <img src="@/assets/images/icon_6.png" class="img">
      <div>
        <div class="itme1_title" style="color: #2DF9CC;">日常发车</div>
        <div class="item1_num" style="color: #29F8E9;">4968</div>
      </div>
    </div>
    </div>
  </div>
  </jtCard>
</template>
<script>
import jtCard from "@/components/Card";
// import ICountUp from "vue-countup-v2";
export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    jtCard,
    // ICountUp,
  },
  data() {
    return {
      delay: 2000,
    };
  },
  methods: {
    onReady: (instance, CountUp, num) => {
      setTimeout(() => {
        instance.reset();
        instance.update(parseInt(num));
      }, 10000);
    },
  },
};
</script>
<style scoped>
.img{
  width: 108px;
  height: 98px;
}
.itme1_title{
  font-size: 25px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  /* color: #2DF9CC; */
}
.item1_num{
  font-size: 33px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  
  padding-top: 10px;
}
.flex{
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.container {
  display: grid;
  padding: 0 35px;
  grid-template-columns: repeat(3, 33.33%);
  grid-template-rows: repeat(2, 50%);
  grid-row-gap: 55px;
}
.item {
  display: flex;
  align-items: center;
}
.item img {
  /* width: 70px;
  height: 70px; */
  margin-right: 30px;
}
.item .item-content {
  display: flex;
  flex-direction: column;
  font-size: 25px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  line-height: 35px;
}
/* .item-content span{

} */
</style>
